import { ListItemButton, ListItemIcon, ListItemText, Radio } from "@mui/material"

export function ReviewProjectPickerRow({ item, selectedProjectId, onSelect }) {
    return (
        <ListItemButton selected={selectedProjectId === item.id} onClick={handleSelect}>
            <ListItemIcon sx={{ minWidth: 40 }}>
                <Radio edge="start" checked={selectedProjectId === item.id} onChange={handleSelect} />
            </ListItemIcon>
            <ListItemText primary={item.title} secondary={item.description || item.status} />
        </ListItemButton>
    )

    function handleSelect() {
        onSelect(item.id)
    }
}
